<template>
  <v-row no-gutters>
    <v-col cols="12">
      <v-skeleton-loader v-if="$store.state.invoices.retrieveLoader" transition="fade-transition" type="table" />
      <template v-else>
        <v-col v-if="!list.length" class="text-center py-5">
          <v-icon class="d-block" color="secondary" size="70">mdi-file</v-icon>
          <span class="d-block subtitle-1">No existen documentos</span>
          <v-btn class="my-5" v-if="showCreate" outlined>Importar un documento</v-btn>
        </v-col>
        <template v-else>
          <v-data-table :headers="headers" :items="list" :items-per-page="pagination" hide-default-header disable-sort mobile-breakpoint hide-default-footer>
            <!-- header -->
            <template v-slot:header="{ props: { headers } }">
              <VTableHeaders :headers="headers" @sort="setSort" />
            </template>
            <!-- end header -->
            <template v-slot:[`item.customer`]="{item}">
              <div class="text-left py-4">
                <v-menu open-on-hover right offset-x :nudge-width="160" transition="slide-x-transition">
                  <template v-slot:activator="{on}">
                    <div v-on="on">
                      <span class="text--secondary font-weight-medium">{{item.customer.name}}</span>
                    </div>
                  </template>
                </v-menu>
              </div>
            </template>
            <template v-slot:[`item.status`]="{item}">
              <v-row align="center" justify="end">
                <v-menu open-on-hover right offset-x :nudge-width="100" transition="slide-x-transition" v-if="item.subscription">
                  <template v-slot:activator="{on}">
                    <v-icon v-on="on" color="secondary">mdi-autorenew</v-icon>
                  </template>
                  <v-card>
                    <v-card-text>
                      <span>Este documento está asociado a una suscripción</span>
                    </v-card-text>
                    <v-divider class="mx-4" />
                    <v-card-actions>
                      <v-spacer />
                      <v-btn text :to="{name: 'SubscriptionRetrieve', params: {id: item.subscription}}" color="primary">Ver suscripción<v-icon small right>mdi-arrow-right</v-icon></v-btn>
                      <v-spacer />
                    </v-card-actions>
                  </v-card>
                </v-menu>
                <div class="text-right" v-if="showStatus">
                  <v-chip v-if="item.status === 'active' && item.due_date <= today" class="mx-1" color="defaultGrey" text-color="secondary" small>Vencido</v-chip>
                  <v-chip v-else-if="item.status === 'active'" class="mx-1" color="defaultGrey" text-color="secondary" small>Pagado<v-icon class="ml-1" x-small>mdi-check</v-icon></v-chip>
                  <v-chip v-else-if="item.status === 'archived'" class="mx-1" color="defaultGrey" text-color="secondary" small>Pagado<v-icon class="ml-1" x-small>mdi-check</v-icon></v-chip>
                </div>
              </v-row>
            </template>
            <template v-slot:[`item.document_type`]="{item}">
              <div class="text-left py-2">
                <span class="d-block">{{item.document_type_display}}</span>
              </div>
            </template>
            <template v-slot:[`item.date_issued`]="{item}">
              <span>{{item.date_issued | date}}</span>
            </template>
            <template v-slot:[`item.valid_until`]="{item}">
              <span>{{item.valid_until | date}}</span>
            </template>
            <template v-slot:[`item.actions`]="{item}">
              <v-menu close-on-click close-on-content-click left offset-y :nudge-bottom="10" transition="slide-y-transition">
                <template v-slot:activator="{ on, attrs }">
                  <v-btn class="ml-2" v-bind="attrs" v-on="on" min-width="34" max-width="34" color="secondary" outlined retain-focus-on-click><v-icon color="secondary">mdi-dots-horizontal</v-icon></v-btn>
                </template>
                <v-list class="pa-0">
                  <v-list-item class="px-5 py-1" :ripple="false">
                    <v-list-item-title class="subtitle-2 font-weight-medium">Ver PDF</v-list-item-title>
                  </v-list-item>

                  <v-list-item v-if="item.subscription" class="px-5 py-1" :to="{ name: 'SubscriptionRetrieve', params: { id: item.subscription } }" :ripple="false">
                    <v-list-item-title class="subtitle-2 font-weight-medium">Ver suscripción</v-list-item-title>
                  </v-list-item>
                  <v-list-item v-else class="px-5 py-1" :ripple="false">
                    <v-list-item-title class="subtitle-2 font-weight-medium">Asignar a suscripción</v-list-item-title>
                  </v-list-item>

                  <v-list-item class="px-5 py-1" :to="{ name: 'CustomerRetrieveUpdate', params: { id: item.customer.id } }" :ripple="false">
                    <v-list-item-title class="subtitle-2 font-weight-medium">Ver cliente</v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-menu>
            </template>
          </v-data-table>
          <template v-if="showPagination || showAll">
            <v-divider />
            <v-row class="mx-0" align="center">
              <v-col cols="12" class="text-center" v-if="showAll">
                <v-btn :to="{name: 'InvoiceList', query: showCriteria}" outlined color="secondary">Ver todas las facturas</v-btn>
              </v-col>
              <template v-if="showPagination">
                <v-col cols="6">
                  <span class="body-2 text--secondary">{{count}} registros</span>
                </v-col>
                <v-col cols="6" class="text-right">
                  <v-pagination v-model="page" :length="totalPages" total-visible="6" />
                </v-col>
              </template>
            </v-row>
          </template>
        </template>
      </template>
    </v-col>
  </v-row>
</template>
<script>
import { mapState } from 'vuex'
import VTableHeaders from '@/components/VTable/VTableHeaders'
import ListViewMixin from '@/mixins/ListViewMixin'
export default {
  components: {
    VTableHeaders
  },
  mixins: [
    ListViewMixin
  ],
  data: () => ({
    headers: [
      { text: 'Cliente', value: 'customer', class: 'font-weight-bold', sortable: true },
      { text: '', value: 'status' },
      { text: 'Tipo', value: 'document_type' },
      { text: 'Fecha', value: 'date_issued', align: 'end', sortable: true },
      { text: 'Vencimiento', value: 'valid_until', align: 'end', sortable: true },
      { text: '', value: 'actions', align: 'end' }
    ]
  }),
  computed: mapState({
    count: state => state.supportingDocuments.documentsCount,
    list: state => state.supportingDocuments.documentsList
  })
}
</script>